import React from 'react';
import { Phone } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const EmergencyButton = () => {
  return (
    <a
      href={`tel:${companyInfo.phoneEmergency.replace(/\s/g, '')}`}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#B91C1C] hover:bg-[#991B1B] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
      aria-label="Appeler pour urgence"
    >
      <Phone className="w-5 h-5 animate-pulse" />
      <span className="font-bold hidden sm:inline">Urgence 24h/24</span>
      <span className="font-bold sm:hidden">Appeler</span>
    </a>
  );
};

export default EmergencyButton;